import { useCallback } from 'react';
import { di } from 'react-magnetic-di';

import type { AsyncFieldConfiguration } from '@atlassian/proforma-form-renderer/async-fields';

import { useLabelsService } from '../../../../../services/labels';

export const LABELS_VALUE_REGEX = /^\S+$/;

export const useLabels = () => {
	di(useLabelsService);
	const { fetch } = useLabelsService();

	return useCallback(
		(systemField: boolean, jiraFieldKey: string): AsyncFieldConfiguration => {
			return {
				createOptions: {
					isValidNewOption: (input: string) => LABELS_VALUE_REGEX.test(input),
				},
				loadOptions: async (query) => {
					let fetchArgument;
					if (systemField) {
						fetchArgument = { query };
					} else {
						const jiraFieldKeyParts = jiraFieldKey.split('_');
						if (jiraFieldKeyParts.length !== 2) {
							return Promise.reject(new Error(`Invalid Jira field key: ${jiraFieldKey}`));
						}
						fetchArgument = { query, customFieldId: jiraFieldKeyParts[1] };
					}
					const data = await fetch(fetchArgument);
					return data.suggestions.map((jiraLabel) => ({
						label: jiraLabel.label,
						value: jiraLabel.label,
					}));
				},
				defaultOptions: true,
			};
		},
		[fetch],
	);
};
